import { useNavigate } from 'react-router-dom';
import '../CSS/style.css';
import '../CSS/Home.css';
// import NewsModal from './newsModal';

function Home() {
  const navigate = useNavigate();

  function toAboutUsPage() {
    navigate('/about');
  }

  return (
    <div className="gx-home-wrapper">
      {/* <NewsModal/> */}
      <section id="home" className="home gx-home-section">
        <div className="wave wave1 gx-wave-fix" />
        <div className="wave wave2 gx-wave-fix" />
        <div className="wave wave3 gx-wave-fix" />
      </section>

      <section id="about" className="about gx-about-section">
        <h1 className="heading gx-about-heading">GenkaiX — Extend limits</h1>
        <div className="row gx-about-row">
          <div className="content gx-about-content">
            <h3 className="gx-about-title">We make creativity work for your brand!</h3>
            <p className="gx-about-text">
              Ours is a team of creatives that is brainstorming on great ideas,
              <b> all. the. time.</b>
              <br />
              With our skills put together, you get an ensemble capable of doing
              anything and everything your brand needs.
            </p>
            <button className="btn gx-about-btn" onClick={toAboutUsPage}>
              About Us
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;